module.exports = __webpack_public_path__ + "media/images/type41-04dbb2a6a82126aad441ecba6ecbecca.png";